import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
import { BENEFITS } from '../../../../config';
import Chip from '@material-ui/core/Chip';
import RichEditorReadOnly from '../../../../components/RichEditorReadOnly/RichEditorReadOnly';
import { JobPropTypes } from '../../../../common/adapters';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '17px'
  },
  titleTopJob: {
    color: theme.palette.text.primary,
    textAlign: 'left',
    fontSize: '33px',
    lineHeight: '53px',
    fontFamily: '"Neufile Grotesk Semi Bold", sans-serif',
    fontWeight: 'bolder',
    marginBottom: '5px'
  },
  jobBtn: {
    textTransform: 'none',
    fontSize: 20,
    marginTop: 40
  },
  jobPreviewBtn: {
    opacity: '0.5'
  },
  chipTags: {
    marginRight: '10px',
    marginBottom: '14px'
  },
  timePostedJob: {
    color: theme.palette.text.primary,
    marginBottom: '34px'
  },
  contentDescription: {
    color: theme.palette.text.primary,
    paddingTop: '16px',
    paddingBottom: '16px',
    paddingLeft: '5px',
    paddingRight: '5px'
  }
}));

const JobView = ({ job, isPreview }) => {
  const classes = useStyles();
  const hasBenefits = job && job.benefits && job.benefits.length > 0;
  const getBenefits = (job) => {
    if (hasBenefits) {
      return job.benefits.split(',').map((option) => {
        const label = BENEFITS.filter((r) => r === option);
        return <Chip key={option} className={classes.chipTags} label={label} />;
      });
    }
  };
  const getRenderEditor = (jobDetails) => (
    <RichEditorReadOnly
      className={classes.contentDescription}
      content={jobDetails ? jobDetails : null}
    />
  );
  const title = job && job.title ? job.title : '';
  const details = job && job.detail ? job.detail : null;
  return (
    <div className={classes.root}>
      <Grid
        alignItems="flex-start"
        container
        direction="column"
        justifyContent="flex-start">
        <Grid item>
          {title && (
            <Typography className={classes.titleTopJob} variant="h1">
              {title}
            </Typography>
          )}
        </Grid>
        {details && (
          <Grid className={classes.contentDescription} item>
            {getRenderEditor(details)}
          </Grid>
        )}
        {hasBenefits && <Grid item>{getBenefits(job)}</Grid>}
      </Grid>
    </div>
  );
};

JobView.propTypes = {
  job: JobPropTypes,
  isPreview: PropTypes.bool.isRequired
};

export default JobView;
